module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "banner"
    }
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "/index.html"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/clubIcon.png")
    }
  }), _c('span', [_vm._v("首页")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/store/index.html"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/storeIcon.png")
    }
  }), _c('span', [_vm._v("旺币商城")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/game/index.html"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/gameIcon.png")
    }
  }), _c('span', [_vm._v("游戏乐园")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/emoji/index.html"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/emojiIcon.png")
    }
  }), _c('span', [_vm._v("表情符号")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9327ce6e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Banner.vue
// module id = 63
// module chunks = 0